import {
    Avatar,
    Flex,
    Header,
    Subheader,
    useStyles,
} from '@archipro-design/aria';
import * as S from './MobileBottomMenuContent.style';
import { getNameInitials } from '@modules/user/util/get-name-initials';

export const MobileMenuAvatar = ({
    name,
    imageUrl,
    email,
}: {
    name: string;
    imageUrl?: string;
    email?: string;
}) => {
    const { css } = useStyles();

    return (
        <Flex className={css(S.MenuAvatar)}>
            <Avatar
                initials={getNameInitials(name)}
                imageFit={imageUrl ? 'contain' : undefined}
                image={
                    imageUrl
                        ? {
                              src: imageUrl,
                              alt: '',
                          }
                        : undefined
                }
                size={48}
            />
            <Flex column>
                <Header>{name}</Header>
                <Subheader>{email}</Subheader>
            </Flex>
        </Flex>
    );
};
